import Vue from 'vue'

import langPt from 'quasar/lang/pt.js'

import './styles/quasar.scss'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/eva-icons/eva-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';import QSpinnerPie from 'quasar/src/components/spinner/QSpinnerPie.js';

Vue.use(Quasar, {
    plugins: {
        Notify,
        Loading,
    },
    config: {
        notify: { position: 'bottom-right', progress: true },
        loading: { backgroundColor: 'primary', spinner: QSpinnerPie },
    },
    lang: langPt,
})
